import mutations from './laboratoryTypesPriceList.mutations'
import actions from './laboratoryTypesPriceList.actions'
import getters from './laboratoryTypesPriceList.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
